import { Component } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  year = new Date().getFullYear();

  isProd = environment.env === 'prod';
  isDev = environment.env === 'dev';
  isStage = environment.env === 'stage';

  languages: any[] = [];

  source = localStorage.getItem('translate-source') === 'local' ? 'local' : 'coindepo';

  currentLang$: any;

  constructor(
    private translateService: TranslateService
  ) {
    this.currentLang$ = this.translateService.onLangChange.asObservable().pipe(
      startWith(''),
      map(() => this.translateService.currentLang),
    );
  }

  changeLang(lang: string = 'en') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.setLocale(lang);
    this.translateService.use(lang);
  }

  changeSource(source: string) {
    this.source = source;
    if (source === 'local') {
      localStorage.setItem('translate-source', 'local');
      this.changeLang('en');
    } else {
      localStorage.removeItem('translate-source');
      this.changeLang('en');
    }
  }
}
